import { NgModule } from '@angular/core';
import { Component } from '@angular/core';

import { PreloadAllModules, RouterModule, Routes, NoPreloading } from '@angular/router';
import { ScrollSpyModule } from 'ngx-scrollspy';

import * as pageComponents from './pages';
import { CheckoutLeaveGuard } from './react-messenger/checkout-leave.guard';

const routes: Routes = [
  // { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: ':provider/callback', component: pageComponents.AuthCallback },
  { path: 'login', component: pageComponents.LoginPage },
  { path: 'signin', component: pageComponents.ClerkLoginModal },
  { path: 'signup', component: pageComponents.ClerkSignUpModal },
  { path: 'clerk-test', component: pageComponents.ClerkTestPage },
  { path: 'login/confirm-email', redirectTo: 'signin', pathMatch: 'full' },
  { path: 'email/reset-password', redirectTo: 'signin', pathMatch: 'full' },
  { path: 'login/google', redirectTo: 'signin', pathMatch: 'full' },
  { path: 'magic/login', redirectTo: 'signin', pathMatch: 'full' },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'auth0/logout', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'find-an-inmate',
    redirectTo: 'add-penmate',
  },
  { path: 'add-penmate', component: pageComponents.ReactSearchPage },
  // The marketing pages link to /search; one canonical route keeps the
  // footer's active state, the boot guard, and analytics in agreement.
  // Angular preserves the query string on redirects.
  { path: 'search', redirectTo: 'add-penmate' },
  // Legacy (v1) add/search surface preserved as an escape hatch, per the messenger cutover pattern.
  { path: 'v1/add-penmate', component: pageComponents.AddPenmatePage },
  {
    component: pageComponents.AddPenmatePage,
    path: 'v1/search',
  },
  {
    component: pageComponents.MyPenmatesPage,
    path: 'my-penmates',
  },
  { path: 'penmates', redirectTo: 'my-penmates', pathMatch: 'full' },
  {
    component: pageComponents.PenmateProfile,
    path: 'penmates/:id',
  },
  // Legacy (v1) message flows preserved for demo users (skipConfirmation).
  {
    component: pageComponents.MessageIndexPage,
    path: 'penmates/:id/v1/messages',
  },
  {
    component: pageComponents.MessageShowPage,
    path: 'penmates/:id/v1/messages/:message_id',
  },
  {
    component: pageComponents.MessageCreatorPage,
    path: 'penmates/:id/v1/new-message',
  },
  {
    component: pageComponents.MessageTextEditor,
    path: 'penmates/:id/v1/new-message/edit-message',
  },
  {
    component: pageComponents.FileUploadModal,
    path: 'penmates/:id/v1/new-message/upload',
  },
  {
    component: pageComponents.SelectedPhotosModal,
    path: 'penmates/:id/v1/new-message/selected-photos',
  },
  {
    component: pageComponents.CreateMessageReturnAddress,
    path: 'penmates/:id/v1/new-message/return-address',
  },
  {
    component: pageComponents.ConfirmOrderPage,
    path: 'penmates/:id/v1/new-message/confirm-order',
  },
  {
    component: pageComponents.IGPhotoPicker,
    path: 'penmates/:id/v1/new-message/instagram-photos',
  },
  {
    component: pageComponents.IGMyPhotosTab,
    path: 'penmates/:id/v1/new-message/instagram-photos/me',
  },
  {
    component: pageComponents.PostcardCreatorPage,
    path: 'penmates/:id/v1/new-postcard',
  },
  {
    component: pageComponents.PostcardDesignPicker,
    path: 'penmates/:id/v1/new-postcard/select-design',
  },
  {
    component: pageComponents.PostcardFileUploadModal,
    path: 'penmates/:id/v1/new-postcard/upload',
  },
  {
    component: pageComponents.PostcardConfirmOrderPage,
    path: 'penmates/:id/v1/new-postcard/confirm-order',
  },
  {
    component: pageComponents.IGPhotoPicker,
    path: 'penmates/:id/v1/new-postcard/instagram-photos',
  },
  {
    component: pageComponents.IGMyPhotosTab,
    path: 'penmates/:id/v1/new-postcard/instagram-photos/me',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/messages',
  },
  {
    component: pageComponents.ReactMessengerPage,
    path: 'penmates/:id/messenger',
    canDeactivate: [CheckoutLeaveGuard],
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/messages/:message_id',
  },
  {
    component: pageComponents.MessagePaymentUpdate,
    path: 'billing/:id/payment',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/new-message/instagram-photos',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/new-postcard/instagram-photos',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/new-message/instagram-photos/me',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/new-postcard/instagram-photos/me',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/new-message',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/new-message/edit-message',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/new-message/upload',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/new-message/selected-photos',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/new-message/return-address',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/new-message/confirm-order',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/new-postcard/upload',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/new-postcard',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/new-postcard/select-design',
  },
  {
    component: pageComponents.MessengerRedirectPage,
    path: 'penmates/:id/new-postcard/confirm-order',
  },
  {
    component: pageComponents.AddCreditsPage,
    path: 'billing/add-credits',
  },
  {
    component: pageComponents.MyAccountPage,
    path: 'my-account',
  },
  {
    component: pageComponents.ConfirmOrderPage,
    path: 'messages/:message_id/send',
  },
  {
    path: 'search/for/:id',
    redirectTo: ':id',
  },
  {
    path: 'inmate-search',
    redirectTo: 'search',
  },
  {
    path: ':id',
    component: pageComponents.PenmateProfile,
  },
  { path: '**', redirectTo: 'not-found' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading }),
    ScrollSpyModule.forRoot(),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
